import { Popover, useTheme } from '@material-ui/core';
import { isBefore } from 'date-fns';
import { useAnchorElement } from 'framework/hooks/useAnchorElement';
import { useStateBoolean } from 'framework/hooks/useStateBool';
import { formatDateX } from 'framework/utils/date/formatDateX';
import { formatTime } from 'framework/utils/date/formatTime';
import { IRosaEventDto } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React, { useMemo } from 'react';
import { getNow } from 'shared/utils/getNow';
import { RosaEventStatusChip } from '../RosaEventStatusChip';
import { RosaEventPopoverContent } from '../popover/RosaEventPopoverContent';
import { useCurrentLanguage } from 'localization/useCurrentLanguage';

interface IProps {
	event: IRosaEventDto;
	style?: React.CSSProperties;
}

export const RosaPatientEventListComponent = ({ event, style }: IProps) => {
	const [isHovered, enter, leave] = useStateBoolean(false);
	const isPast = useMemo(() => isBefore(new Date(event.endsAt ?? event.startsAt), getNow()), [event]);
	const [anchor, open, close] = useAnchorElement();
	const strings = useLocalization();
	const theme = useTheme();
	const userLanguage = useCurrentLanguage();

	return (
		<>
			{Boolean(anchor) && (
				<Popover
					open={Boolean(anchor)}
					anchorEl={anchor}
					onClose={close}>
					<RosaEventPopoverContent
						event={event}
						close={close}
					/>
				</Popover>
			)}
			<div
				onClick={open}
				onMouseEnter={enter}
				onMouseLeave={leave}
				className='df-row-ac'
				style={{
					width: '100%',
					cursor: 'pointer',
					borderRadius: 32,
					backgroundColor: isHovered ? '#f6f6f6' : 'inherit',
					paddingLeft: 8,
					paddingRight: 8,
					paddingTop: 4,
					paddingBottom: 4,
					opacity: isPast ? 0.8 : 1,
					...style,
				}}>
				<div className='df-row-ac'>
					<div style={{ display: 'flex', marginRight: 6, marginBottom: 3 }}>
						<div style={{ borderRadius: 12, border: `6px solid ${event.motiveHexColor}` }}></div>
					</div>
					<div style={{ fontWeight: 'bold', marginRight: 6 }}>{formatDateX(event.startsAt, 'eee dd/MM/yyyy', userLanguage)}</div>
					<div
						style={{
							width: '100px',
							textDecoration: event.isNoShow ? 'line-through' : 'inherit',
							color: event.isNoShow ? theme.palette.error.main : 'inherit',
						}}>
						{event.isAllDay ? strings.fullDay : `${formatTime(event.startsAt)} - ${formatTime(event.endsAt)}`}
					</div>
					{event.isActive === false && (
						<RosaEventStatusChip
							style={{ marginRight: 8 }}
							event={event}
						/>
					)}
				</div>
				<div style={{ color: event.motiveHexColor, marginRight: 8 }}>{event.motiveLabel}</div>
				{event.hasSite && <div>{`@${event.siteName}`}</div>}
			</div>
		</>
	);
};
